import React from 'react';

import Search from '../../search';
import FilterHistory from '../../historico/filter-history';
import Modal from '../../modal/modalGenericV2';

import FilterIcon from '../../../assets/icons/icon-Tune.png';
import iconTable from '../../../assets/icons/totvs/icon-card-gray.png';
import iconCardGray from '../../../assets/icons/totvs/icon-table-gray.png';

import * as S from './styles';

const SolicitacaoFilters = ({
  variant = 'toolbar',
  viewMode,
  onToggleView,
  search,
  onSearchChange,
  onSearchBlur,
  onClearSearch,
  hasFilterOptions,
  showFilters,
  onOpenFilters,
  onCloseFilters,
  filterHistoryProps,
}) => {
  if (variant === 'desktop-sidebar') {
    return hasFilterOptions ? (
      <S.DesktopSidebar>
        <FilterHistory {...filterHistoryProps} />
      </S.DesktopSidebar>
    ) : null;
  }

  return (
    <>
      <S.ToolbarContainer>
        <S.ToolbarContent>
          <S.ToggleButton
            onClick={onToggleView}
            aria-pressed={viewMode === 'card'}
          >
            <img
              src={viewMode === 'table' ? iconCardGray : iconTable}
              alt={viewMode === 'table' ? 'Ícone de tabela' : 'Ícone de cartão'}
            />
          </S.ToggleButton>

          <S.SearchFilterGroup>
            <Search
              placeholder="Número da Receita, Nome do Produto, etc"
              value={search}
              onChange={onSearchChange}
              onBlur={onSearchBlur}
              onClear={onClearSearch}
            />

            {hasFilterOptions && (
              <S.FilterImage
                src={FilterIcon}
                alt="Abrir filtros"
                onClick={onOpenFilters}
              />
            )}
          </S.SearchFilterGroup>
        </S.ToolbarContent>
      </S.ToolbarContainer>

      <Modal
        show={showFilters}
        size="sm"
        onHide={onCloseFilters}
      >
        <FilterHistory {...filterHistoryProps} />
      </Modal>
    </>
  );
};

export default SolicitacaoFilters;
